import {
  FormSelectDataType,
  ListLoader,
  ListOptionsProps,
  ListOptionsWrapper,
  MAX_PANEL_HEIGHT,
  renderOption,
} from '@systemeio/ui'
import { useState } from 'react'

export interface ListOptionsAsyncProps extends ListOptionsProps {
  isFetching?: boolean
  moreItems?: number
}

export function ListOptionsAsync({
  isFetching,
  optionsClassName,
  data,
  loaderWrapperClassName,
  loaderClassName,
  moreItems,
  asOptions,
  asOption,
  ...optionProps
}: ListOptionsAsyncProps) {
  const [listRef, setListRef] = useState<HTMLElement | null>(null)

  let height = 0
  if (listRef) {
    const options = listRef.querySelectorAll('[role="option"]')

    options.forEach(option => {
      height += option.getBoundingClientRect().height
    })

    height = data && !isFetching ? Math.min(height, MAX_PANEL_HEIGHT) || MAX_PANEL_HEIGHT : 42
  }

  return (
    <ListOptionsWrapper
      as={asOptions}
      ref={setListRef}
      optionsClassName={optionsClassName}
      style={{ height }}
    >
      {({ option: item }: { option?: FormSelectDataType }) => {
        if (isFetching) {
          return (
            <ListLoader
              loaderWrapperClassName={loaderWrapperClassName}
              loaderClassName={loaderClassName}
            />
          )
        }
        return renderOption({ as: asOption, item, ...optionProps })
      }}
    </ListOptionsWrapper>
  )
}
